module.exports = __webpack_public_path__ + "img/mail-icon.0b2eabb0.svg";